var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuditLog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_435_15378)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_435_15378)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.719661 13.7197C1.01255 13.4268 1.48743 13.4268 1.78032 13.7197L4.49999 16.4393L7.21965 13.7197C7.51255 13.4268 7.98742 13.4268 8.28031 13.7197C8.57321 14.0126 8.57321 14.4874 8.28031 14.7803L5.03032 18.0303C4.73742 18.3232 4.26255 18.3232 3.96966 18.0303L0.719661 14.7803C0.426768 14.4874 0.426768 14.0126 0.719661 13.7197Z",
    fill: "#404349"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05212 6.76901C6.18769 5.26158 7.78241 4.16404 9.59599 3.64175C11.4096 3.11946 13.3438 3.20073 15.1072 3.87329C16.8705 4.54586 18.3676 5.7733 19.3727 7.37066C20.3778 8.96803 20.8366 10.8488 20.6799 12.7296C20.5232 14.6103 19.7595 16.3892 18.5039 17.7982C17.2482 19.2072 15.5687 20.17 13.7183 20.5414C11.8679 20.9129 9.94696 20.6729 8.24483 19.8577C7.87125 19.6788 7.71345 19.2309 7.89238 18.8573C8.0713 18.4837 8.51919 18.3259 8.89276 18.5049C10.3016 19.1796 11.8916 19.3782 13.4231 19.0708C14.9546 18.7633 16.3447 17.9665 17.384 16.8003C18.4233 15.6341 19.0554 14.1617 19.1851 12.605C19.3148 11.0483 18.9351 9.49165 18.1031 8.16953C17.2712 6.84742 16.0321 5.83149 14.5726 5.27481C13.1131 4.71814 11.5122 4.65088 10.0111 5.08317C8.51003 5.51546 7.1901 6.42388 6.25021 7.67155C5.31696 8.9104 4.80859 10.4171 4.80014 11.9675L5.24702 16.9328C5.28415 17.3453 4.97981 17.7099 4.56727 17.747C4.15472 17.7841 3.79019 17.4798 3.75306 17.0673L3.30306 12.0672C3.30103 12.0447 3.30002 12.022 3.30004 11.9994C3.30164 10.1121 3.91655 8.27644 5.05212 6.76901Z",
    fill: "#404349"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.25C12.4142 7.25 12.75 7.58579 12.75 8V11.9802L16.2633 13.2978C16.6512 13.4432 16.8477 13.8755 16.7022 14.2633C16.5568 14.6512 16.1245 14.8477 15.7367 14.7022L11.7367 13.2022C11.4439 13.0925 11.25 12.8126 11.25 12.5V8C11.25 7.58579 11.5858 7.25 12 7.25Z",
    fill: "#404349"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_435_15378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_435_15378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.2132,
    height: 21.2132,
    fill: "white",
    transform: "translate(-3 12) rotate(-45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditLog);
export default __webpack_public_path__ + "static/media/auditLog.d654a647e1c0710d6f9ac04185e28e22.svg";
export { ForwardRef as ReactComponent };